module.exports = __webpack_public_path__ + "img/caseai2.268304e9.png";